<template>
  <div class="form">
    <div class="form__container">
      <form @submit.prevent="handleLogin()">
        <span class="input__container" :class="{error: err}">
          <input :class="{error: err}" name="username" v-model="username" type="text" id="username" placeholder="Username" />
          <img class="input__img" src="/img/username.svg" alt="Username Logo" />
        </span>
        
        <span class="input__container" :class="{error: err}">
          <input name="password" v-model="password" type="password" id="password" placeholder="Password" />
          <img class="input__img" src="/img/password.svg" alt="Username Logo" />
        </span>
        
        <button type="submit">Login</button>
      </form>
      
    </div>
  </div>
</template>

<script>
  import LoginController from '../Controller/LoginController.vue';
  import jwt_decode from 'jwt-decode';
  export default {
    extends: LoginController,
    data() {
      return {
        username: '',
        password: '',
        err: false,
      }
    },
    methods: {
      async handleLogin() {
        this.login(this.username, this.password)
          .then(data => {
            if(data.status !== undefined && data.status === 200) {
              const decoded = jwt_decode(data.refreshToken)
              this.$store.dispatch('user/setUser', {
                firstName: decoded.firstName,
                lastName: decoded.lastName,
                role: 0,
                id: decoded.id,
                job: decoded.job,
                roleId: decoded.roleId
              }, { root: true })
              window.localStorage.setItem('_rToken', data.refreshToken)
              var now = new Date();
              var time = now.getTime();
              var expireTime = time + (1000 * 60 * 20) // 20 mins
              now.setTime(expireTime)
              document.cookie = `accessToken=${data.accessToken};expires=${now.toUTCString()};SameSite=None;secure`
              this.$router.push('/dashboard')
            } else {
              this.err = true;
              this.$emit('setErrorMessage', data.msg)
            }
          })
      }
    }
  }
</script>

<style>
  .form__container {
    width: 50%;
    margin: 30px auto;
    backdrop-filter: blur(5px);
  }
  input {
    height: 30px;
    display: block;
    margin: 0 auto 10px;
    background: transparent;
    border: none;
    padding: 10px;
    padding-left: 35px;
    font-size: 1.2em;
    padding-bottom: 0;
    color: #fff;
    border-bottom: solid 1px white
  }

  input::placeholder {
    color: #FFF
  }
  input:focus {
    outline: none
  }

  .input__container {
    display: inline-block;
    position: relative;
    display: block;
    max-width: 281px;
    margin: 0 auto
  }

  .input__img {
    width: 15px;
    position: absolute;
    left: 15px;
    top: 10px;
  }

  .input__container.error input {
    border-bottom: solid 1px red;
    transition: border-bottom 0.1s;
  }

  .input__container.error img {
    filter: invert(24%) sepia(91%) saturate(7075%) hue-rotate(357deg) brightness(95%) contrast(120%);
    transition: all 0.1s;
  }

  #username:focus + img, #password:focus + img {
    width: 20px;
    top: 5px;
    left: 13px;
    transition: all 0.15s
  }

  button {
    font-size: 1.2em;
    width: 100px;
    padding: 10px;
    border-radius: 50px;
    border: none;
    margin-top: 20px;
    cursor: pointer;
  }
</style>